import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { convertClassifiedReceipt, deleteClassifiedReceipt } from "store/actions/receiptActions";
//#endregion
//#region types
import { ACTION_SEPARATOR, MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { DialogEnums, StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { ClassifiedReceiptMoreActionProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import { MoreActions } from "components/common";
import { useDocumentDraftService } from "serviceHooks";
import ConvertToGenericDocumentFormContainer from "../forms/convertToGenericDocumentFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ClassifiedReceiptMoreActions: React.FC<ClassifiedReceiptMoreActionProps> = (props) => {
  const documentDraftService = useDocumentDraftService();
  const dispatch = useDispatch();

  const onClickDelete = async () => {
    return documentDraftService.deleteDocumentDraft(props.classifiedReceipt.id);
  };

  const onDeleteSuccess = () => {
    dispatch(deleteClassifiedReceipt(props.classifiedReceipt.id));
    props.markAsDone && props.markAsDone();
  };

  const onConvertSuccess = () => {
    dispatch(convertClassifiedReceipt(props.classifiedReceipt.id));
    props.markAsDone && props.markAsDone();
  };

  const deleteDraftAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Delete),
    icon: IconDefinitionConstants.WTrashAlt,
    actionDialog: {
      isOpen: false,
      title: `${LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Common.Discard
      )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.SubmittedDocument)}?`,
      titleIcon: IconDefinitionConstants.WTrashAlt,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Remove),
          onClick: onClickDelete,
          type: StyleEnums.DisplayType.Danger,
          successMessage: TranslationKeys.DocumentDraft.CancelSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Message,
      children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DeleteWarningMessage),
      type: StyleEnums.DisplayType.Danger,
    },
    highlightType: StyleEnums.DisplayType.Danger,
    onActionSuccess: onDeleteSuccess,
  };

  const convertDraftToGenericDocumentAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Receipt.ClassifiedReceiptMoreActionsConvertToGenericDocumentDescription
    ),
    icon: IconDefinitionConstants.WCommentDots,
    actionDialog: {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Receipt.ClassifiedReceiptMoreActionsConvertToGenericDocumentDescription
      ),
      subTitle: LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Receipt.ClassifiedReceiptMoreActionsConvertToGenericDocumentSubTitle
      ),
      titleIcon: IconDefinitionConstants.WSupportCircle,
      dialogType: DialogEnums.DialogType.Content,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Submit),
        },
      ],
      maxWidth: "sm",
      children: <ConvertToGenericDocumentFormContainer classifiedReceipt={props.classifiedReceipt} />,
    },
    onActionSuccess: onConvertSuccess,
  };

  return <MoreActions menuItems={[convertDraftToGenericDocumentAction, ACTION_SEPARATOR, deleteDraftAction]} />;
};

export default ClassifiedReceiptMoreActions;
